import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { Ablamm, AblammCreateRequest, AblammUpdateRequest, Behandlung, Schaf, SchafSaveRequest } from './schaf.types';


@Injectable({ providedIn: 'root' })
export class SchafService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrlV1}`;

  getSchafe(): Observable<{ data: Schaf[] } | Schaf[]> {
    return this.http.get<{ data: Schaf[] } | Schaf[]>(`${this.apiUrl}/getSchafe`);
  }

  getSchafById(id: number): Observable<{ data: Schaf }> {
    return this.http.get<{ data: Schaf }>(`${this.apiUrl}/schaf/${id}`);
  }

  getSchafByTransponder(transponder: string) {
    return this.http.get<any>(`${this.apiUrl}/schaf/transponder/${transponder}`);
  }

  createSchaf(payload: SchafSaveRequest): Observable<{ message: string; data: { schafId: number} }> {
   return this.http.post<{ message: string; data: { schafId: number} }>(`${this.apiUrl}/schaf`, payload);
  }

  updateSchaf(id: number, payload: SchafSaveRequest): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(`${this.apiUrl}/schaf/${id}`, payload);
  }

  uploadSchafImage(schafId: number, file: File): Observable<{ message: string; data: { url: string } }> {
    const formData = new FormData();
    formData.append('image', file);
    return this.http.post<{ message: string; data: { url: string } }>(
      `${this.apiUrl}/schaf/${schafId}/image`,
      formData,
    );
  }

  getAblammHistorie(schafNr: string): Observable<{data: Ablamm[]}> {
    return this.http.get<{data: Ablamm[]}>(`${this.apiUrl}/schaf/${schafNr}/ablamm`);
  }

  createAblamm(schafNr: string, payload: AblammCreateRequest): Observable<{ message: string; data: Ablamm }> {
   return this.http.post<{ message: string; data: Ablamm }>(`${this.apiUrl}/schaf/${schafNr}/ablamm`, payload);
  }

  updateAblamm(schafNr: string, ablammId: number, payload: AblammUpdateRequest): Observable<{ message: string; data: Ablamm }> {
    return this.http.put<{ message: string; data: Ablamm }>(`${this.apiUrl}/schaf/${schafNr}/ablamm/${ablammId}`, payload);
  }

  getBehandlung(schafNr: string): Observable<{ data: Behandlung[]}> {
    return this.http.get<{ data: Behandlung[] }>(`${this.apiUrl}/schaf/${schafNr}/behandlung`);
  }
}
